import { render, staticRenderFns } from "./Privileges.vue?vue&type=template&id=5f4c35ca&scoped=true&"
import script from "./Privileges.vue?vue&type=script&lang=js&"
export * from "./Privileges.vue?vue&type=script&lang=js&"
import style0 from "./Privileges.vue?vue&type=style&index=0&id=5f4c35ca&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f4c35ca",
  null
  
)

export default component.exports